/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */
const menuInit = () => {
  // Elements
  const dropdowns: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.header__menu--desktop .menu__item--has-children',
  );
  const subMenus: NodeListOf<HTMLElement> = document.querySelectorAll('.header__menu--mobile .submenu');
  const subMenuTemplate = document.getElementById('submenu-back') as HTMLTemplateElement;

  // Strings
  const menuItemActive: string = 'menu__item--active';
  const menuSubmenuActive: string = 'menu__submenu--active';

  // Mediaqueries
  const mediaQuery: MediaQueryList = window.matchMedia('(max-width: 991.95px)');

  // -------------------------------
  // Desktop Logic
  // -------------------------------
  // Close all dropdowns
  const closeDropdowns = () => {
    [...dropdowns].forEach((dropdown: HTMLElement): void => {
      dropdown.classList.remove(menuItemActive);
    });
  };

  // Open or close dropdown when parent item is clicked
  [...dropdowns].forEach((dropdown: HTMLElement): void => {
    const childLink: HTMLElement = dropdown.querySelector('.menu__link');

    childLink.addEventListener('click', (e: Event): void => {
      e.preventDefault();

      // Is clicked dropdown active?
      const isActive: boolean = dropdown.classList.contains(menuItemActive);

      // Remove active classes from all items
      closeDropdowns();

      // Add active class to current click if clicked child
      // was not active
      if (!isActive) dropdown.classList.add(menuItemActive);
    }, { capture: true });
  });

  // -------------------------------
  // Mobile Logic
  // -------------------------------
  [...subMenus].forEach((item): void => {
    const menuLink = item.previousSibling as HTMLElement;
    const cloneSubmenuItem = subMenuTemplate.content.cloneNode(true) as HTMLElement;
    const headerBack = cloneSubmenuItem.querySelector<HTMLElement>('.header__back');
    item.prepend(cloneSubmenuItem);

    menuLink.addEventListener('click', (e): void => {
      e.preventDefault();
      item.classList.toggle(menuSubmenuActive);
    });

    headerBack.addEventListener('click', (): void => {
      item.classList.toggle(menuSubmenuActive);
    });
  });

  const closeSubmenus = () => {
    [...subMenus].forEach((submenu): void => {
      submenu.classList.remove(menuSubmenuActive);
    });
  };

  // -------------------------------
  // Shared Logic
  // -------------------------------
  // Remove active class of all dropdown parents
  // when clicked anywhere in document
  document.addEventListener('click', (): void => {
    if (mediaQuery.matches) {
      closeSubmenus();
    } else {
      closeDropdowns();
    }
  });
};

export default menuInit;
